<template>
    <div class="size-container-placeholder">
        <Placeholder class='option-title-placeholder'/>
        <Placeholder class='option-button-placeholder'/>
    </div>
</template>
<script>
import Placeholder from '@/ecom/components/loading/Placeholder.vue';

export default {
    components: {Placeholder}    
}
</script>
<style lang="scss" scoped>
.size-container-placeholder {
    display: flex;
    flex-direction: column;
    gap: 10px
}
.option-title-placeholder{
    width: 22%; 
    height: 25px;
}

.option-button-placeholder{
    width: 100%; 
    height: 40px;
}
</style>